import request from '@/utils/request'
//消息列表
export function marqueeList(query) {
  return request({
    url: 'system/marquee/list',
    method: 'get',
    params: query
  })  
}

//新增
export function marqueeAdd(data) {
  return request({
    url: 'system/marquee',
    method: 'post',
    data: data
  })
}
//查询
export function queryMarquee(marqueeId) {
  return request({
    url: 'system/marquee/'+ marqueeId,
    method: 'get',
  })
}

//修改
export function upDataMarquee(data) {
  return request({
    url: 'system/marquee',
    method: 'put',
    data: data
  })
}
//删除
export function delMarquee(marqueeId) {
  return request({
    url: 'system/marquee/' + marqueeId,
    method: 'delete'
  })
}
//发布&撤销
export function marqueeStatus(marqueeId) {
  return request({
    url: 'system/marquee/update-status/'+marqueeId,
    method: 'put',
  })
}

//跑马灯列表
export function carousel(query) {
  return request({
    url: 'system/marquee/carousel',
    method: 'get',
    params: query
  })  
}